import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { PathSelectorProvider } from "@/context/PathSelectorContext";
import Layout from "@/components/layout/Layout";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import ServiceDetail from "@/pages/ServiceDetail";
import ForEmployers from "@/pages/ForEmployers";
import ForCandidates from "@/pages/ForCandidates";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import LegalPage from "@/pages/LegalPage";

function App() {
  return (
    <BrowserRouter>
      <PathSelectorProvider>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/services/:slug" element={<ServiceDetail />} />
            <Route path="/for-employers" element={<ForEmployers />} />
            <Route path="/for-candidates" element={<ForCandidates />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<LegalPage title="Privacy Policy" />} />
            <Route path="/terms" element={<LegalPage title="Terms of Service" />} />
            <Route path="/cookies" element={<LegalPage title="Cookie Policy" />} />
          </Route>
        </Routes>
        <Toaster position="bottom-right" richColors />
      </PathSelectorProvider>
    </BrowserRouter>
  );
}

export default App;
